var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack631({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.82,3.91H6.41V8.17a8.75,8.75,0,0,0,.06,1.32,1.29,1.29,0,0,0,.48.78,1.74,1.74,0,0,0,1,.29,1.57,1.57,0,0,0,1-.28,1.1,1.1,0,0,0,.42-.68,9.82,9.82,0,0,0,.07-1.34V3.91H11.1V8a11.19,11.19,0,0,1-.13,2,2.29,2.29,0,0,1-.48,1,2.52,2.52,0,0,1-.92.64,4.07,4.07,0,0,1-1.52.24,4.44,4.44,0,0,1-1.71-.26A2.43,2.43,0,0,1,5.42,11,2.14,2.14,0,0,1,5,10.11a9.94,9.94,0,0,1-.15-2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack631);
export default __webpack_public_path__ + "static/media/Symbolpack_6_31.4ea1e0d22b3517aa618be0c0b5dd8867.svg";
export { ForwardRef as ReactComponent };